import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import icons from '../../assets/json/icons.json';
import newicons from '../../assets/json/newicons.json';
import iconsForPatient from '../../assets/json/iconsForPatient.json';

@Injectable({
  providedIn: 'root'
})
export class IconService {
  iconList: any[] = icons;
  newIconList: any[] = newicons;
  iconsForPatient: any[] = iconsForPatient;

  constructor(
    private domSanitizer: DomSanitizer,
    public matIconRegistry: MatIconRegistry
  ) {
    this.getIcon();
  }

  getIcon() {
    [...this.iconList, ...this.newIconList, ...this.iconsForPatient].forEach((icon: any) => {
      try {
        if (icon?.name && icon?.value) {
          this.matIconRegistry.addSvgIcon(
            icon.name,
            this.setPath(`assets/svgIcons/${icon.value}`)
          );
        } else {
          console.warn(`[IconService] Invalid icon entry:`, icon);
        }
      } catch (error) {
        console.error(`[IconService] Failed to register icon "${icon?.name}" →`, error);
      }
    });
  }

  private setPath(url: string): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
